import {FormControl, InputAdornment, styled} from '@mui/material'
import Input from './Input'
import BrokenImageOutlinedIcon from '@mui/icons-material/BrokenImageOutlined'
import {Texts} from 'appearance'

const ImageUploadInput = ({label, width, style, height, dataTestId, ...p}) => {
    return (
        <FormControl variant="outlined" style={{width, ...style}} {...p}>
            {label && <Label>{label}</Label>}
            <Input
                {...p}
                height={height}
                variant="outlined"
                type="file"
                accept="image/*"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <BrokenImageOutlinedIcon />
                        </InputAdornment>
                    ),
                }}
                style={{flex: 3}}
            />
            {/* <input type="file" accept="image/*" style={{display: 'none'}} /> */}
        </FormControl>
    )
}

export default ImageUploadInput

const Label = styled(Texts.BoldText)`
    font-size: 16px;
    flex: 1;
`
